module.exports = __webpack_public_path__ + "img/hr-assembling-machine-1.09255376.png";